import React from 'react';
import {
 Button, Form, FormGroup, Label, Col, Container, Row, FormText
} from 'reactstrap';
import SelectListComponent from "../utils/selectList";
import DateSelector from '../utils/dateSelector';


const SearchPanel = ({contentErrorText,depAirportsId,depAirports,airlines,airlinesId, onSearch, startDateChange,handleAirlineChange,handleAirportChange }) => {
    return (
       <div>
            <Form ref={this.form} onSubmit={e => e.preventDefault()}>
                <Container>
                    <Row>
                        <Col xs="12" md="3">
                            <FormGroup className="mb-4">
                                <Label>Select Month</Label>
                                <DateSelector
                                    dayNotAllowed={true}
                                    maxDate={new Date()}
                                    todayDate={(new Date()).toString()}
                                    name="startDate" onValueChange={startDateChange} />
                            </FormGroup>
                        </Col>
                            <Col xs="12" md="3">
                                <FormGroup className="mb-4">
                                    <Label for="Airline">Select Airline</Label>
                                    <SelectListComponent placeholder={'Select Airline...'} data={airlines} valueKey='Id' textField='Name' selectValue={airlinesId} onValueChange={(payload) =>handleAirlineChange(payload)} />
                                    { contentErrorText && <FormText color="danger"> {contentErrorText }</FormText> }

                                </FormGroup>
                            </Col>


                        <Col xs="12" md="3">
                                <FormGroup className="mb-4 ">
                                    <Label for="DepartureAirportId">Select Source Airport</Label>
                                    <SelectListComponent data={depAirports} valueKey='Id' textField='Name' selectValue={depAirportsId} onValueChange={handleAirportChange} />
                                 </FormGroup>
                            </Col>
                        <Col xs="12" md="3" >
                            <Button  style={{marginTop:'25px'}} className="btn-avi-primary" onClick={() => onSearch(1)}>Search</Button>
                        </Col>
                    </Row>
                </Container>
            </Form>

       </div>
        )

    };


export default SearchPanel;



// WEBPACK FOOTER //
// ./src/views/oldBilledPerAirport/billedPerAirport-panel.js